import { Form, Formik } from "formik";
import React, { useContext, useEffect, useState } from "react";
import { Card, CardHeader, Col, Input, Row } from "reactstrap";
import * as Yup from "yup";
import SignContext from "../../contextAPI/Context/SignContext";
import { useFormSubmit } from "../../hooks/useFormSubmit";
import { toast } from "react-toastify";

const VitalsandHistory = (props) => {
  const { setVitalAndHistory, GetSpecificVital, editVital } =
    useContext(SignContext);
  console.log(props.vitalid);

  // Debounce hook for form submissions
  const { handleSubmit: debouncedSubmit } = useFormSubmit(500);

  const [vital, setvital] = useState({
    height: "",
    weight: "",
    bmi: "",
    pulse: "",
    bp: "",
    temperature: "",
    complaints: "",
    pastHistory: "",
    personalHistory: "",
    familyHistory: "",
  });

  const handleSubmitData = async (values) => {
    // Validate required IDs before submission
    if (!props.employeeId) {
      toast.error("Please select an employee first");
      return;
    }

    if (!props.companyId) {
      toast.error("Please select a company first");
      return;
    }

    if (!props.checkupDataId) {
      toast.error("Please complete employee selection and submit before adding vitals");
      return;
    }

    // Backend expects { data: { ...fields } } format with required IDs
    const data = {
      employeeId: props.employeeId,
      companyId: props.companyId,
      checkupDataId: props.checkupDataId,
      chackupNameId: props.chackupNameId, // Fixed prop name
      checkupTypeId: props.checkupTypeId,
      ...values,
    };

    try {
      const response = await setVitalAndHistory({ data });
      console.log(response);

      if (response && (response.data || response.success)) {
        toast.success("Vitals and history saved successfully!");
        if (props.onSuccess && response.data?._id) {
          props.onSuccess(response.data._id);
        }
      }
    } catch (error) {
      console.error("Error saving vitals:", error);
      const errorMessage = error.response?.data?.message || error.response?.data?.error || "Failed to save vitals and history";
      toast.error(errorMessage);
    }
  };

  const validationSchema = Yup.object().shape({
    // Numeric fields - optional but validated if provided (matching backend)
    height: Yup.number()
      .nullable()
      .transform((value, originalValue) => originalValue === "" ? null : value)
      .min(50, "Height must be at least 50 cm")
      .max(300, "Height must not exceed 300 cm")
      .typeError("Height must be a number"),
    weight: Yup.number()
      .nullable()
      .transform((value, originalValue) => originalValue === "" ? null : value)
      .min(20, "Weight must be at least 20 kg")
      .max(300, "Weight must not exceed 300 kg")
      .typeError("Weight must be a number"),
    bmi: Yup.number()
      .nullable()
      .transform((value, originalValue) => originalValue === "" ? null : value)
      .min(10, "BMI must be at least 10")
      .max(60, "BMI must not exceed 60")
      .typeError("BMI must be a number"),
    pulse: Yup.number()
      .nullable()
      .transform((value, originalValue) => originalValue === "" ? null : value)
      .min(30, "Pulse must be at least 30 bpm")
      .max(200, "Pulse must not exceed 200 bpm")
      .integer("Pulse must be a whole number")
      .typeError("Pulse must be a number"),
    // String fields - optional (matching backend)
    bp: Yup.string().nullable(),
    temperature: Yup.string().nullable(),
    complaints: Yup.string().nullable(),
    pastHistory: Yup.string().nullable(),
    personalHistory: Yup.string().nullable(),
    familyHistory: Yup.string().nullable(),
  });
  const gettingid = async () => {
    if (props.vitalid !== null) {
      const res = await GetSpecificVital(props.vitalid);
      console.log(">>>vital", res.data);
      setvital(res.data);
    }
    // console.log(vital.temperature);
  };
  const calculateBMI = (height, weight) => {
    const heightInMeters = height / 100; // Convert height to meters
    const bmi = weight / (heightInMeters * heightInMeters);
    return isNaN(bmi) ? "" : bmi.toFixed(2);
  };
  useEffect(() => {
    gettingid();
  }, [props.vitalid]);
  useEffect(() => { }, []);
  return (
    <>
      <div className="alert alert-info mb-3">
        <small>
          <i className="ri-information-line me-1"></i>
          Fields marked with <span className="text-danger">*</span> have validation rules. All vitals are optional.
        </small>
      </div>
      {props.vitalid !== null ? (
        <Row>
          <Col lg={12}>
            <Formik
              initialValues={{
                vital,
              }}
              onSubmit={async (values, { resetForm, setSubmitting }) => {
                await debouncedSubmit(async () => {
                  const data = {
                    ...props,
                    ...vital,
                    chackupNameId: props.chackupNameId,
                    checkupTypeId: props.checkupTypeId,
                  };
                  console.log(data);
                  try {
                    const res = await editVital(props.vitalid, data);
                    if (res && (res.data || res.success)) {
                      toast.success("Vitals and history updated successfully!");
                      if (props.onSuccess) {
                        props.onSuccess(props.vitalid);
                      }
                    }
                  } catch (error) {
                    console.error("Error:", error);
                    const errorMessage = error.response?.data?.message || error.response?.data?.error || "Failed to update vitals";
                    toast.error(errorMessage);
                  } finally {
                    setSubmitting(false);
                  }
                });
              }}
            >
              {({
                isSubmitting,
                handleChange,
                handleSubmit,
                errors,
                touched,
                values,
                handleBlur,
                setFieldValue,
              }) => (
                <Form
                  onSubmit={handleSubmit}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && e.target.type !== 'textarea') {
                      e.preventDefault();
                    }
                  }}
                >
                  <Card>
                    <CardHeader>
                      <Row className="g-1 m-1">
                        <Col className="col-sm">
                          <div className="d-flex justify-content-sm-between">
                            <h2 className="card-title mb-0 justify-content-sm-start">
                              <strong>Vitals</strong>
                            </h2>
                          </div>
                        </Col>
                      </Row>
                    </CardHeader>
                    <div className="card-body">
                      <div className="live-preview">
                        <Row className="align-items-center g-3">
                          <Col lg={2} md={4}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Height <span className="text-danger">*</span>
                                <small className="text-muted"> (50-300 cm)</small>
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="number"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="height"
                                  name="height"
                                  min="50"
                                  max="300"
                                  step="0.1"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) => {
                                    const newHeight = e.target.value;
                                    const bmi = calculateBMI(newHeight, vital.weight);
                                    setvital({
                                      ...vital,
                                      height: newHeight,
                                      bmi: bmi
                                    });
                                    handleChange(e);
                                    setFieldValue("bmi", bmi);
                                  }}
                                  onBlur={handleBlur}
                                  value={
                                    vital
                                      ? vital.height !== null &&
                                        vital.height !== ""
                                        ? vital.height
                                        : ""
                                      : ""
                                  }

                                // value={(vital.height !== null && vital.height !== "") ? vital.height : (vital.height !== null ? vital.height : "")}
                                />
                                <p className="error text-danger">
                                  {errors.height &&
                                    touched.height &&
                                    errors.height}
                                </p>
                              </div>
                            </div>
                          </Col>
                          <Col lg={2} md={4}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Weight <span className="text-danger">*</span>
                                <small className="text-muted"> (20-300 kg)</small>
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="number"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="weight"
                                  name="weight"
                                  min="20"
                                  max="300"
                                  step="0.1"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) => {
                                    const newWeight = e.target.value;
                                    const bmi = calculateBMI(vital.height, newWeight);
                                    setvital({
                                      ...vital,
                                      weight: newWeight,
                                      bmi: bmi
                                    });
                                    handleChange(e);
                                    setFieldValue("bmi", bmi);
                                  }}
                                  onBlur={handleBlur}
                                  value={
                                    vital
                                      ? vital.weight !== null &&
                                        vital.weight !== ""
                                        ? vital.weight
                                        : ""
                                      : ""
                                  }
                                />
                                <p className="error text-danger">
                                  {errors.weight &&
                                    touched.weight &&
                                    errors.weight}
                                </p>
                              </div>
                            </div>
                          </Col>
                          <Col lg={2} md={4}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                BMI
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="number"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="bmi"
                                  name="bmi"
                                  min="10"
                                  max="60"
                                  step="0.01"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={
                                    vital
                                      ? vital.bmi !== null && vital.bmi !== ""
                                        ? vital.bmi
                                        : ""
                                      : ""
                                  }
                                />
                                <p className="error text-danger">
                                  {errors.bmi && touched.bmi && errors.bmi}
                                </p>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row className="align-items-center g-3">
                          <Col lg={2} md={4}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Pulse <span className="text-danger">*</span>
                                <small className="text-muted"> (30-200 bpm)</small>
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="number"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="pulse"
                                  name="pulse"
                                  min="30"
                                  max="200"
                                  step="1"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) =>
                                    setvital({
                                      ...vital,
                                      pulse: e.target.value,
                                    })
                                  }
                                  onBlur={handleBlur}
                                  value={
                                    vital
                                      ? vital.pulse !== null &&
                                        vital.pulse !== ""
                                        ? vital.pulse
                                        : ""
                                      : ""
                                  }
                                />
                                <p className="error text-danger">
                                  {errors.pulse &&
                                    touched.pulse &&
                                    errors.pulse}
                                </p>
                              </div>
                            </div>
                          </Col>
                          <Col lg={2} md={4}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                BP
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="bp"
                                  name="bp"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) =>
                                    setvital({
                                      ...vital,
                                      bp: e.target.value,
                                    })
                                  }
                                  onBlur={handleBlur}
                                  value={
                                    vital
                                      ? vital.bp !== null && vital.bp !== ""
                                        ? vital.bp
                                        : ""
                                      : ""
                                  }
                                />
                                <p className="error text-danger">
                                  {errors.bp && touched.bp && errors.bp}
                                </p>
                              </div>
                            </div>
                          </Col>
                          <Col lg={2} md={4}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Temperature
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="temperature"
                                  name="temperature"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) =>
                                    setvital({
                                      ...vital,
                                      temperature: e.target.value,
                                    })
                                  }
                                  onBlur={handleBlur}
                                  value={
                                    vital
                                      ? vital.temperature !== null &&
                                        vital.temperature !== ""
                                        ? vital.temperature
                                        : ""
                                      : ""
                                  }
                                />
                                <p className="error text-danger">
                                  {errors.temp && touched.temp && errors.temp}
                                </p>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <CardHeader>
                          <Row className="g-1 m-1">
                            <Col className="col-sm">
                              <div className="d-flex justify-content-sm-between">
                                <h2 className="card-title mb-0 justify-content-sm-start">
                                  <strong>Medical History</strong>
                                </h2>
                              </div>
                            </Col>
                          </Row>
                        </CardHeader>
                        <Row className=" m-1">
                          <Col lg={6} md={8}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Complaints
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="complaints"
                                  name="complaints"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) =>
                                    setvital({
                                      ...vital,
                                      complaints: e.target.value,
                                    })
                                  }
                                  onBlur={handleBlur}
                                  value={
                                    vital
                                      ? vital.complaints !== null &&
                                        vital.complaints !== ""
                                        ? vital.complaints
                                        : ""
                                      : ""
                                  }
                                />

                                <p className="error text-danger">
                                  {errors.complaints &&
                                    touched.complaints &&
                                    errors.complaints}
                                </p>
                              </div>
                            </div>
                          </Col>
                          <Col lg={6} md={8}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Past History
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="past history"
                                  name="pastHistory"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) =>
                                    setvital({
                                      ...vital,
                                      pastHistory: e.target.value,
                                    })
                                  }
                                  onBlur={handleBlur}
                                  value={
                                    vital
                                      ? vital.pastHistory !== null &&
                                        vital.pastHistory !== ""
                                        ? vital.pastHistory
                                        : ""
                                      : ""
                                  }
                                />

                                <p className="error text-danger">
                                  {errors.pastHistory &&
                                    touched.pastHistory &&
                                    errors.pastHistory}
                                </p>
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <Row className="m-1">
                          <Col lg={6} md={8}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Personal History
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="personal history"
                                  name="personalHistory"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) =>
                                    setvital({
                                      ...vital,
                                      personalHistory: e.target.value,
                                    })
                                  }
                                  onBlur={handleBlur}
                                  value={
                                    vital
                                      ? vital.personalHistory !== null &&
                                        vital.personalHistory !== ""
                                        ? vital.personalHistory
                                        : ""
                                      : ""
                                  }
                                />

                                <p className="error text-danger">
                                  {errors.personalHistory &&
                                    touched.personalHistory &&
                                    errors.personalHistory}
                                </p>
                              </div>
                            </div>
                          </Col>
                          <Col lg={6} md={8}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Family History
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="family history"
                                  name="familyHistory"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) =>
                                    setvital({
                                      ...vital,
                                      familyHistory: e.target.value,
                                    })
                                  }
                                  onBlur={handleBlur}
                                  value={
                                    vital
                                      ? vital.familyHistory !== null &&
                                        vital.familyHistory !== ""
                                        ? vital.familyHistory
                                        : ""
                                      : ""
                                  }
                                />

                                <p className="error text-danger">
                                  {errors.familyHistory &&
                                    touched.familyHistory &&
                                    errors.familyHistory}
                                </p>
                              </div>
                            </div>
                          </Col>
                        </Row>

                      </div>
                    </div>

                    <div className="text-end mb-3 me-3">
                      <button
                        className="btn btn-success w-sm"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            Updating...
                          </>
                        ) : (
                          'Update'
                        )}
                      </button>
                    </div>
                  </Card>
                </Form>
              )}
            </Formik>
          </Col>
        </Row >
      ) : (
        <Row>
          <Col lg={12}>
            <Formik
              initialValues={{
                height: "",
                weight: "",
                bmi: "",
                pulse: "",
                bp: "",
                temperature: "",
                complaints: "",
                pastHistory: "",
                familyHistory: "",
              }}
              validationSchema={validationSchema}

              onSubmit={async (values, { resetForm, setSubmitting }) => {
                await debouncedSubmit(async () => {
                  try {
                    await handleSubmitData(values);
                  } catch (error) {
                    console.error("Error:", error);
                  } finally {
                    setSubmitting(false);
                  }
                });
              }}
            >
              {({
                isSubmitting,
                handleChange,
                handleSubmit,
                errors,
                touched,
                values,
                handleBlur,
                setFieldValue,
              }) => (
                <Form
                  onSubmit={handleSubmit}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && e.target.type !== 'textarea') {
                      e.preventDefault();
                    }
                  }}
                >
                  <Card>
                    <CardHeader>
                      <Row className="g-1 m-1">
                        <Col className="col-sm">
                          <div className="d-flex justify-content-sm-between">
                            <h2 className="card-title mb-0 justify-content-sm-start">
                              <strong>Vitals</strong>
                            </h2>
                          </div>
                        </Col>
                      </Row>
                    </CardHeader>
                    <div className="card-body">
                      <div className="live-preview">
                        <Row className="align-items-center g-3">
                          <Col lg={2} md={4}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Height <span className="text-danger">*</span>
                                <small className="text-muted"> (50-300 cm)</small>
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="number"
                                  className={`form-control ${errors.height && touched.height
                                    ? "is-invalid"
                                    : touched.height && values.height
                                      ? "is-valid"
                                      : ""
                                    }`}
                                  id="product-orders-input"
                                  placeholder="height"
                                  name="height"
                                  min="50"
                                  max="300"
                                  step="0.1"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) => {
                                    handleChange(e);
                                    const bmi = calculateBMI(
                                      e.target.value,
                                      values.weight
                                    );
                                    handleChange({
                                      target: { name: "bmi", value: bmi },
                                    });
                                  }}
                                  onBlur={handleBlur}
                                  value={values.height}
                                />
                                <p className="error text-danger">
                                  {errors.height &&
                                    touched.height &&
                                    errors.height}
                                </p>
                              </div>
                            </div>
                          </Col>
                          <Col lg={2} md={4}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Weight <span className="text-danger">*</span>
                                <small className="text-muted"> (20-300 kg)</small>
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="number"
                                  className={`form-control ${errors.weight && touched.weight
                                    ? "is-invalid"
                                    : touched.weight && values.weight
                                      ? "is-valid"
                                      : ""
                                    }`}
                                  id="product-orders-input"
                                  placeholder="weight"
                                  name="weight"
                                  min="20"
                                  max="300"
                                  step="0.1"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) => {
                                    handleChange(e);
                                    const bmi = calculateBMI(
                                      values.height,
                                      e.target.value
                                    );
                                    setFieldValue("bmi", bmi);
                                  }}
                                  onBlur={handleBlur}
                                  value={values.weight}
                                />
                                <p className="error text-danger">
                                  {errors.weight &&
                                    touched.weight &&
                                    errors.weight}
                                </p>
                              </div>
                            </div>
                          </Col>
                          <Col lg={2} md={4}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                BMI
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="number"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="bmi"
                                  name="bmi"
                                  min="10"
                                  max="60"
                                  step="0.01"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.bmi}
                                  readOnly
                                />
                                <p className="error text-danger">
                                  {errors.bmi && touched.bmi && errors.bmi}
                                </p>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row className="align-items-center g-3">
                          <Col lg={2} md={4}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Pulse <span className="text-danger">*</span>
                                <small className="text-muted"> (30-200 bpm)</small>
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="number"
                                  className={`form-control ${errors.pulse && touched.pulse
                                    ? "is-invalid"
                                    : touched.pulse && values.pulse
                                      ? "is-valid"
                                      : ""
                                    }`}
                                  id="product-orders-input"
                                  placeholder="pulse"
                                  name="pulse"
                                  min="30"
                                  max="200"
                                  step="1"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.pulse}
                                />
                                <p className="error text-danger">
                                  {errors.pulse &&
                                    touched.pulse &&
                                    errors.pulse}
                                </p>
                              </div>
                            </div>
                          </Col>
                          <Col lg={2} md={4}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                BP
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="bp"
                                  name="bp"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.bp}
                                />
                                <p className="error text-danger">
                                  {errors.bp && touched.bp && errors.bp}
                                </p>
                              </div>
                            </div>
                          </Col>
                          <Col lg={2} md={4}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Temperature
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="temperature"
                                  name="temperature"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.temperature}
                                />
                                <p className="error text-danger">
                                  {errors.temp && touched.temp && errors.temp}
                                </p>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <CardHeader>
                          <Row className="g-1 m-1">
                            <Col className="col-sm">
                              <div className="d-flex justify-content-sm-between">
                                <h2 className="card-title mb-0 justify-content-sm-start">
                                  <strong>Medical History</strong>
                                </h2>
                              </div>
                            </Col>
                          </Row>
                        </CardHeader>
                        <Row className=" m-1">
                          <Col lg={6} md={8}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Complaints
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="complaints"
                                  name="complaints"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.complaints}
                                />

                                <p className="error text-danger">
                                  {errors.complaints &&
                                    touched.complaints &&
                                    errors.complaints}
                                </p>
                              </div>
                            </div>
                          </Col>
                          <Col lg={6} md={8}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Past History
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="past history"
                                  name="pastHistory"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.pastHistory}
                                />

                                <p className="error text-danger">
                                  {errors.pastHistory &&
                                    touched.pastHistory &&
                                    errors.pastHistory}
                                </p>
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <Row className="m-1">
                          <Col lg={6} md={8}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Personal History
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="personal history"
                                  name="personalHistory"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.personalHistory}
                                />

                                <p className="error text-danger">
                                  {errors.personalHistory &&
                                    touched.personalHistory &&
                                    errors.personalHistory}
                                </p>
                              </div>
                            </div>
                          </Col>
                          <Col lg={6} md={8}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Family History
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="family history"
                                  name="familyHistory"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.familyHistory}
                                />

                                <p className="error text-danger">
                                  {errors.familyHistory &&
                                    touched.familyHistory &&
                                    errors.familyHistory}
                                </p>
                              </div>
                            </div>
                          </Col>
                        </Row>

                      </div>
                    </div>

                    <div className="text-end mb-3 me-3">
                      <button
                        className="btn btn-success w-sm"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            Submitting...
                          </>
                        ) : (
                          'Submit'
                        )}
                      </button>
                    </div>
                  </Card>
                </Form>
              )}
            </Formik>
          </Col>
        </Row >
      )}
    </>
  );
};

export default VitalsandHistory;
